import DailyExpenseMonthList from "../components/DailyExpense/DailyExpenseMonthList";

export default function DailyExpenseListPage() {
  return <DailyExpenseMonthList />;
}
